export default "__VITE_ASSET__Pf2f51w1__"